import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/1c2d2ee2/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Specs`}</h2>
    <p>{`Cards have `}<inlineCode parentName="p">{`16px | 1 rem`}</inlineCode>{` margins all around, including dashboard widgets.`}</p>
    <Row mdxType="Row">
  <Column colMd={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.1195652173913%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsSAAALEgHS3X78AAABS0lEQVQoz5WSfW+CMBDG/f7faX9sn2DLspeYOKa2QASBitdre+11hSka3cz25MeFQI/nKddZPIo5/lezdPkQDLm/rKbgDdGpmXzYOnysIOtoRXZl7dIO9Rrh3BywQhM58sGZI8Zwf7d/eSirvjbOh+RwRQqWWhYZiRYjB55i6xgWtVaF0npvNFpET8QhXBCJarSlNjHdT80QwsrCdlPmeTGpvNImPYV+k2LvMRiX/vC3Mz+9Q/6Zy1zeUCHF26sqOhNkbdYV+zA6M88rKES+llL8Ti5EVqoShth8Hls6xF2nmla1P9O1bd80lYGNsdFPe2ZWTM8l5iu9NVAD1Fqn2hjceZpQRECUpiU1npzT3HtyHx0uGyPTMAFFD+sRMaDXOxB7LYyVxmZaq/GQnGIfDmfwQx50vNMD/bF2wOM+h7fHwPG8mY8fu62LZV+hn+0ctzFCqQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cards should have 16px margins all around",
            "title": "Cards should have 16px margins all around",
            "src": "/static/8bcc4a58f3633cf46c2e6943af182c0c/d2d67/general-card-specs-2.png",
            "srcSet": ["/static/8bcc4a58f3633cf46c2e6943af182c0c/7fc1e/general-card-specs-2.png 288w", "/static/8bcc4a58f3633cf46c2e6943af182c0c/a5df1/general-card-specs-2.png 576w", "/static/8bcc4a58f3633cf46c2e6943af182c0c/d2d67/general-card-specs-2.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  <Caption mdxType="Caption">Structure and spacing measurements for small side panels | px | rem.</Caption>
  </Column>
    </Row>
    <h2>{`Typography`}</h2>
    <p>{`All card titles, captions and labels are set in sentence case. Set body text appropriately based on content.`}</p>
    <Row mdxType="Row">
  <Column colMd={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "118.34239130434783%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAIAAAB1KUohAAAACXBIWXMAAAsSAAALEgHS3X78AAABOUlEQVQ4y62U2XaDMAxE+f+v5LDve6AUg3uDaSBAArSZBx8hPJIYSWhSyrZty7Ksqqppmu/TGIZBg5znuW3blmUlSdL3PS++jkAaIYRGADKbphkEQRiG8IkljyBG3Mld1/m+77ouTPLHcXxIhjKRqVNexJo8jPgjGaCWeI1+ASh3Mpw0TRFM13WMuq5vv1jaoHzGREZ31ELtKIqyLEM2TjTHIBwGJ56dzKrsoigIxj0MrlYjeORUebCXinxIbSyltnqxNVb2p/v8r7IvYZ7t+hnNiMf2bDFvFWHoIfvAnHieR6tpOB6i0CHHcQzDYGHZHNqmpgWDjk6ZiaTIjAq34TymlUt4uLCsWc3FLBh5iKfKhrP8MB5XfVqT36iy9e+Qt/t4ivyqVafI/MO6PbQjtn70m1dSXIcS9QeVXH/NQPkkGgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cards should have 16px margins all around",
            "title": "Cards should have 16px margins all around",
            "src": "/static/df42f05a1aae9318fcf92c51ed35ea21/d2d67/card-headings.png",
            "srcSet": ["/static/df42f05a1aae9318fcf92c51ed35ea21/7fc1e/card-headings.png 288w", "/static/df42f05a1aae9318fcf92c51ed35ea21/a5df1/card-headings.png 576w", "/static/df42f05a1aae9318fcf92c51ed35ea21/d2d67/card-headings.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  <Caption mdxType="Caption">Structure and spacing measurements for small side panels | px | rem.</Caption>
  </Column>
    </Row>
    <h3>{`Double heading`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Carbon token`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`rem`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`px`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`productive-heading-05`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`32`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Caption / subtitle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`label-01`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Large heading`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Carbon token`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`rem`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`px`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`heading-03`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.25`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Small heading (heading and caption)`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Carbon token`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`rem`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`px`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`productive-heading-01`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`14`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Caption / subtitle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`label-01`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Body`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Body text / Descriptions`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Carbon token`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`rem`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`px`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cards with < 4 lines)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`body-short-01`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`14`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cards with > 4 lines)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`body-long-01`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`14`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Color`}</h2>
    <p>{`For general card usage, use a white card when the page background color is `}<strong parentName="p">{`gray 10`}</strong>{`.`}</p>
    <p>{`If you need to draw attention to a card with unique content such as a special offering on the catalog page, use a `}<strong parentName="p">{`gray 90`}</strong>{` or gradient color background for the card. Please refrain from using marketing messages that may cause the user to percieve the card as an advertisement.`}</p>
    <Row mdxType="Row">
  <Column colMd={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "736px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.03260869565217%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsSAAALEgHS3X78AAABB0lEQVQoz8WRu26DMBRA8639gS7d6OCKLkk3JAZQ9w4d+w+VkPoBIMprRC4NGGMMfvUGkrQRGRp16JG5tq/u8QOvzB9YwVfXdRRFcRxnWZamaZIkeZ6HYVgURVVVnxMwwPiDbDHZloQQrQ9yEASWZSGEbNu+P3CHkOM4vu97ngfRdd3NZn1z+3B1bTuPz1qpnay1FkKUZYkx7rqun4CeMg5T2AQiYwziwNnT67h+kW/vvTHgTTuDzDlX02IzUpleGCEV5PV8xB9IKZTS+2ODvKww8+KngAJtHPf1l8kzx/p/l4dhGBecTQLHv7iTYd40Dfk1lNITuW1buuBsEoA3/5ZhpC5kvvwXTRji3JEuwUoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Card colors",
            "title": "Card colors",
            "src": "/static/9f9ad6b72a3a9e5d001be181383bdcd5/d2d67/card-color.png",
            "srcSet": ["/static/9f9ad6b72a3a9e5d001be181383bdcd5/7fc1e/card-color.png 288w", "/static/9f9ad6b72a3a9e5d001be181383bdcd5/a5df1/card-color.png 576w", "/static/9f9ad6b72a3a9e5d001be181383bdcd5/d2d67/card-color.png 736w"],
            "sizes": "(max-width: 736px) 100vw, 736px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  <Caption mdxType="Caption">On gray 10 page/section backgrounds use white cards. <br />
  On white page/section backgrounds or places where you want to draw attention use gray 90 cards.</Caption>
  </Column>
    </Row>
    <h2>{`Buttons and links`}</h2>
    <p>{`Cards use floating default buttons (primary, secondary, ghost, etc.) Arrow icons can also be used in cards on overview pages.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      